import React from 'react';
import PropTypes from 'prop-types';

export default function IconAturBesaranSubsidi({ className, color = '#588B2C', stroke = '#fff' }) {

  return (
    <svg
      className={className}
      fill="none"
      height="18"
      viewBox="0 0 18 18"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 2.25H10.5L13.5 5.25V14.25C13.5 14.6642 13.1642 15 12.75 15H4.5C4.08579 15 3.75 14.6642 3.75 14.25V3C3.75 2.58579 4.08579 2.25 4.5 2.25Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M10.5 2.25V5.25H13.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <circle cx="4.5" cy="13.5" fill={color} r="3.75" />
      <path
        d="M4.5 11.625V15.375M2.625 13.5H6.375"
        stroke={stroke}
        strokeLinecap="round"
        strokeWidth="1.25"
      />
    </svg>
  );
}

IconAturBesaranSubsidi.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
};
